// 檢查字數限制
export const handleOverLengthString = (editor, stringMaxLength) => {
    const html = editor.html.get(true);
    const isOverLength = Boolean(stringMaxLength > html.length) ? false : true;

    if (isOverLength) editor.html.set(html.substring(0, stringMaxLength));
};

export function processContent(content = '', callbacks = []) {
    return callbacks.reduce((acc, cb) => cb(acc), content);
}

export function replaceEmptyLink(content = '') {
    return content.replace(/href="#"/gi, () => {
        return 'href="javascript:void(0);"';
    });
}

export function removeHref(content = '') {
    return content.replace(/<a\s+([^>]*?)href="[^"]*"\s*([^>]*)>/gi, '<a $1 $2>');
}

/**
 * 翻譯下拉選單標題
 *
 * 此函數用於翻譯下拉選單中所有帶有 title 屬性的 <a> 元素
 *
 * @param {Object} editor - Froala 編輯器實例
 * @param {Object} $dropdown - 下拉選單元素
 * @returns {void}
 */
export function translateDropdownTitle(editor, $dropdown) {
    const aTag = $dropdown.find('a'); // 取得下拉選單項目帶有 title 屬性的元素

    Object.entries(aTag).forEach(([, element]) => {
        // 更新下拉選單項目的 title 屬性
        if (element && element.nodeType === Node.ELEMENT_NODE && element.title) {
            element.title = editor.language.translate(element.title);
        }
    });
}
